import React, { useEffect } from "react";
import { FaRupeeSign, FaBitcoin } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import limit from "../assets/images/limit-buy.svg";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Filler,
} from "chart.js";
import master from "../assets/images/icon/master.png";
import visa from "../assets/images/icon/visa.png";
import { useLocation } from "react-router-dom";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Filler
);

const LimitBuy = () => {
  const location = useLocation();

  const chartData = {
    labels: [
      "2025-08-05 17:30",
      "18:00",
      "18:30",
      "19:00",
      "19:30",
      "20:00",
      "20:20",
      "20:40",
      "21:00",
      "22:00",
      "23:00",
      "00:00",
      "01:00",
      "02:00",
      "06:00",
      "11:30",
    ],
    datasets: [
      {
        label: "Bitcoin Price",
        data: [
          99200, 99000, 98800, 98500, 98000, 97500, 97365.6, 97700, 98000,
          98200, 98500, 98700, 98550, 98400, 98600, 98450,
        ],
        borderColor: "#f2b705", // Yellow color
        backgroundColor: "transparent",
        pointRadius: 4,
        pointHoverRadius: 6,
        pointHoverBorderWidth: 2,
        tension: 0.4,
        fill: false,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      y: {
        ticks: {
          callback: (value) => `${(value / 1000).toFixed(2)}K`,
          color: "#6b7280",
        },
        grid: {
          color: "#e5e7eb",
        },
      },
      x: {
        ticks: {
          color: "#6b7280",
        },
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: "#fff",
        titleColor: "#000",
        bodyColor: "#000",
        borderColor: "#e5e7eb",
        borderWidth: 1,
        padding: 10,
        callbacks: {
          title: (tooltipItems) => {
            const raw = tooltipItems[0].label;
            const [date, time] = raw.split(" ");
            return `${date} ${time ?? ""}`;
          },
          label: (tooltipItem) => `€ ${tooltipItem.formattedValue}`,
        },
      },
      legend: {
        display: false,
      },
    },
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div className="p-8">
      <h1 className="text-4xl font-bold mb-2">Limit Buy</h1>
      <p className="mb-6 text-sm text-gray-500 flex items-center gap-2">
        Supported <img src={visa} className="inline h-5" alt="visa" />
        <img src={master} className="inline h-5" alt="mastercard" />
      </p>

      <div className="flex flex-col md:flex-row gap-8">
        {/* Left: Buy the dip box */}
        <div className="w-full md:w-1/2 border rounded-xl p-6">
          <h2 className="text-lg font-semibold mb-2">Buy the dip</h2>
          <p className="text-sm mb-4">
            Place a limit buy order to purchase crypto at your preferred target
            price.
          </p>
          <div className="flex justify-center">
            <img src={limit} alt="illustration" className="h-40" />
          </div>
        </div>

        {/* Right: Buy with Target Price box */}
        <div className="w-full md:w-1/2 border rounded-xl p-6 shadow-sm">
          <h2 className="text-lg font-semibold mb-6">Buy with Target Price</h2>

          {/* Spend input */}
          <div className="border rounded-lg px-4 py-3 mb-4 flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Spend</p>
              <p className="text-xl font-semibold">1,500 - 100,000</p>
            </div>
            <div className="flex items-center gap-1 text-yellow-500 font-medium">
              <FaRupeeSign />
              INR
              <MdKeyboardArrowDown />
            </div>
          </div>

          {/* Receive input */}
          <div className="border rounded-lg px-4 py-3 mb-4 flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Receive</p>
              <p className="text-xl font-semibold">0</p>
            </div>
            <div className="flex items-center gap-1 text-yellow-500 font-medium">
              <FaBitcoin />
              BTC
              <MdKeyboardArrowDown />
            </div>
          </div>

          {/* Target price box */}
          <div className="bg-gray-100 rounded-lg px-4 py-3 mb-6 flex items-center justify-between">
            <p className="text-sm text-gray-500">Target Price:</p>
            <div className="text-sm">
              <span className="font-semibold text-black">
                10,110,820.55 INR
              </span>
              <span className="text-red-500 ml-2">↓ 2%</span>
            </div>
          </div>

          <button className="bg-yellow-400 hover:bg-yellow-300 transition w-full py-3 rounded-lg font-semibold text-black">
            Verify Identity
          </button>
        </div>
      </div>
      {/* How to Buy Crypto */}
      <div className="mb-8">
        <h2 className="text-3xl font-bold my-10">How to Buy Crypto</h2>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="p-6 border rounded-lg shadow text-center">
            <img
              src="https://cdn-icons-png.flaticon.com/512/3064/3064197.png"
              alt="Step 1"
              className="mx-auto h-12 mb-4"
            />
            <h3 className="font-bold mb-2">1. Enter Amount & Select Payment</h3>
            <p className="text-sm">
              Enter the amount, select the available payment method, and choose
              the payment account or bind the payment card.
            </p>
          </div>
          <div className="p-6 border rounded-lg shadow text-center">
            <img
              src="https://cdn-icons-png.flaticon.com/512/1170/1170576.png"
              alt="Step 2"
              className="mx-auto h-12 mb-4"
            />
            <h3 className="font-bold mb-2">2. Confirm Order</h3>
            <p className="text-sm">
              Confirmation of transaction detail information, including trading
              pair quotes, fees, and other explanatory tips.
            </p>
          </div>
          <div className="p-6 border rounded-lg shadow text-center">
            <img
              src="https://cdn-icons-png.flaticon.com/512/190/190411.png"
              alt="Step 3"
              className="mx-auto h-12 mb-4"
            />
            <h3 className="font-bold mb-2">3. Receive Crypto</h3>
            <p className="text-sm">
              After successful payment, the purchased crypto will be deposited
              into your Spot or Funding Wallet.
            </p>
          </div>
        </div>
      </div>

      {/* Bitcoin Market Overview */}
      <div className="grid md:grid-cols-2 gap-6">
        {/* Chart */}
        <div className="p-6 border rounded-lg shadow w-96 max-w-auto sm:w-full">
          <h2 className="text-2xl font-bold mb-2">Bitcoin Markets</h2>
          <p className="text-lg mb-4">BTC/EUR</p>
          <p className="text-2xl font-bold">€98,571.62</p>
          <p className="text-red-500">-0.29%</p>
          {/* Insert chart component here if available */}
          <div className="mt-4 flex items-center justify-center ">
            <div className="w-full h-96">
              <Line data={chartData} options={chartOptions} />
            </div>
          </div>
        </div>

        {/* Market Info */}
        <div className="p-6 border rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">Markets</h2>
          <div className="space-y-2 text-sm">
            <p>
              <strong>Popularity:</strong> #1
            </p>
            <p>
              <strong>Market Cap:</strong> €1,961.83B
            </p>
            <p>
              <strong>Circulation Supply:</strong> 19.90M
            </p>
            <p>
              <strong>Volume:</strong> €49.62B
            </p>
          </div>
          <p className="mt-4 text-sm">
            Bitcoin is experiencing a decline in value this week. Currently,
            Bitcoin is priced at €98,571.62 per BTC, with a circulating supply
            of 19.90M BTC, resulting in a total market capitalization of
            €1,961.83B.
          </p>
          <p className="mt-2 text-sm">
            Over the past 24 hours, the trading volume for Bitcoin has increased
            by €76.57B, representing a 1.5432% rise. Moreover, BTC worth €49.62B
            has been traded in the last day.
          </p>
          <div className="mt-4 text-lg">
            <h3 className="font-semibold">Conversion Tables</h3>
            <p className="text-red-500 text-sm">7 days exchange rate: -3.45%</p>
            <p className="text-red-500 text-sm">
              24-hour exchange rate: -1.29%
            </p>
            <p className="text-red-500 text-sm">
              1 month exchange rate: -0.29%
            </p>
            <p className="text-red-500 text-sm">
              3 month exchange rate: -33.29%
            </p>
            <p>Bitcoin's exchange rate is experiencing an increase</p>
            <p>
              Currently, the value of 1 BTC is 98,502.48 EUR, indicating that
              purchasing 5 BTC would cost 492,512.42 EUR. Conversely, 1.00 EUR
              can be exchanged for 0.0000102 BTC, and 50.00 EUR can be exchanged
              for 0.0005076 BTC, exclusive of platform or gas fees.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LimitBuy;
